import Layout from '../components/Layout';

const PRIVATE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScB_wBC_P8LivyBE_rox_LlzB51e3Ym2yeu2GAR71s9HMWyEw/viewform?usp=dialog';

const resorts = [
  { name: 'Big White', oneway: 500, round: 850 },
  { name: 'Revelstoke', oneway: 900, round: 1500 },
  { name: 'Silverstar', oneway: 600, round: 900 },
];

export default function PrivateBookings() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Private Booking</h1>
        <p className="text-sm sm:text-base text-gray-400 mt-1">
          Flat-rate private shuttles for your group. Last-minute (within 24hrs) adds 20%.
        </p>

        {/* Resort fixed rates */}
        <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6">
          {resorts.map((r) => (
            <div key={r.name} className="rounded-2xl bg-zinc-900/40 border border-white/5 p-5 shadow-[0_1px_0_rgba(255,255,255,0.04)]">
              <div className="font-semibold text-lg">{r.name}</div>
              <div className="mt-3 text-sm text-gray-300 space-y-1">
                <div>One way: <span className="text-white font-semibold">${r.oneway}</span></div>
                <div>Round trip: <span className="text-white font-semibold">${r.round}</span></div>
              </div>
            </div>
          ))}
        </div>

        {/* Hourly section */}
        <div className="mt-6 rounded-2xl bg-zinc-900/40 border border-white/5 p-5">
          <div className="font-semibold text-lg">Private Shuttles (hourly)</div>
          <ul className="mt-2 text-sm text-gray-300 space-y-1 list-disc pl-5">
            <li>Minimum 4 hours — <span className="text-white font-semibold">$195/hr</span></li>
            <li>After 10pm — <span className="text-white font-semibold">$225/hr</span></li>
            <li>8-hour booking — <span className="text-white font-semibold">$1300</span></li>
            <li className="text-gray-400">Last-minute (within 24hrs): +20%</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <a
            href={PRIVATE_FORM_URL}
            target="_blank"
            rel="noreferrer"
            className="rounded-full px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold"
          >
            Request a private booking
          </a>
          <a
            href="/"
            className="rounded-full px-4 py-2 border border-white/10 hover:bg-white/5"
          >
            Back to homepage
          </a>
        </div>
      </div>
    </Layout>
  );
}
